import React from 'react';
import ChartLegendLabel from './label';

const Legend = ({
  labels,
  onClick,
}) => (
  <ul className='legend'>
    {labels.map((label) => (
      <ChartLegendLabel
        key={label.value}
        onClick={() => onClick(label)}
        {...label}
      />
    ))}
  </ul>
);

export default Legend;
